export const Elevator = (): JSX.Element => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="18"
    fill="none"
    viewBox="0 0 16 18"
  >
    <path
      stroke="#363BC4"
      strokeMiterlimit="10"
      d="M7.336 3.179h1.328m-3.997 0h1.335m3.996 0h1.335M8 5.366V17m-8 0h16M1.328 1h13.338v16H1.328zm2.669 4.366h8V17h-8z"
    />
  </svg>
);
